import styled from 'styled-components';

export const Td = styled.td`
  padding-top: 5px !important;
  padding-bottom: 5px !important;
`;
